import httpClient, { ConexaResponse } from '@/services/httpClient'
import platform from '@/utils/platform'
import {
  IRequestCallTokenGroupResponse,
  IRequestCallTokenGroupReturnType,
  IRequestCallTokenResponse,
  IRequestTokenData,
} from './realtime-attendance-types'

interface SendMetricsPayload {
  callingTimes: number
  status: string
}

export const sendMetrics = async (
  callId: number,
  payload: SendMetricsPayload,
): Promise<void> => {
  const data = {
    quantidadeAlertasChamada: payload.callingTimes,
    abaPlataformaEmSegundoPlano: document.visibilityState === 'hidden',
    status: payload.status,
    plataforma: 'WEB',
    dispositivo: platform.device(),
    sistemaOperacional: platform.os(),
    navegador: platform.browser(),
  }
  await httpClient
    .post(
      `/integration/app-paciente/atendimento/chamada/${callId}/metrica`,
      data,
    )
    .catch(err => console.log(err))
}

export const validateCallToken = async (
  idAtendimento: string,
  idProfissional: string,
  date: string,
  tokenAutorizacaoExterno: string,
  numeroGuiaPrestador: string,
): Promise<void> => {
  const dataHoraAgendamento = date.replace(',', '')
  return httpClient
    .post(
      'integration/app-empresa-externa/elegibilidade/chamada/validar-token',
      {
        idAtendimento,
        idProfissional,
        dataHoraAgendamento,
        tokenAutorizacaoExterno,
        numeroGuiaPrestador,
      },
    )
    .then(d => d.data.object)
}

export const requestCallToken = async (
  requestData: IRequestTokenData,
): Promise<ConexaResponse<IRequestCallTokenResponse>> => {
  const { idAtendimento, idProfissional, dataHoraAgendamento } = requestData
  const response = await httpClient.post(
    'integration/app-empresa-externa/elegibilidade/chamada/solicitar-token',
    {
      idAtendimento,
      idProfissional,
      dataHoraAgendamento,
    },
  )
  return response.data
}

export const verifyTokenStatus = async (
  attendanceId: number,
): Promise<boolean> => {
  try {
    const response = await httpClient.get(
      `/integration/app-empresa-externa/elegibilidade/atendimento/${attendanceId}/token`,
    )
    return response.data.object
  } catch (err) {
    console.error(err)
  }
}

export const validateCallTokenGroup = async (
  idAtendimento: string,
  idProfissional: string,
  dataHoraAgendamento: string,
  tokenAutorizacaoExterno: string,
  numeroGuiaPrestador: string,
): Promise<void> => {
  return httpClient
    .post('/eligibility/validate-token', {
      appointmentGroupId: idAtendimento,
      professionalId: idProfissional,
      date: dataHoraAgendamento,
      authorizationToken: tokenAutorizacaoExterno,
      providerGuideNumber: numeroGuiaPrestador,
    })
    .then(d => d.data.object)
}

export const requestCallTokenGroup = async (
  idAtendimento: string,
  idProfissional: string,
  dataHoraAgendamento: string,
): Promise<IRequestCallTokenGroupReturnType> => {
  const response = await httpClient.post<
    ConexaResponse<IRequestCallTokenGroupResponse>
  >('/eligibility/request-token', {
    appointmentGroupId: idAtendimento,
    professionalId: idProfissional,
    date: dataHoraAgendamento,
  })

  const parsedResponse: IRequestCallTokenGroupReturnType = {
    elegible: response.data.object.elegivel,
    providerGuideNumber: response.data.object.numeroGuiaPrestador,
    operatorGuideNumber: response.data.object.numeroGuiaOperadora,
    message: response.data.object.mensagem,
    validatedToken: response.data.object.tokenJaValidado,
  }

  return parsedResponse
}
